import { render, staticRenderFns } from "./CalendarShare.vue?vue&type=template&id=19976c5a&scoped=true&"
import script from "./CalendarShare.vue?vue&type=script&lang=js&"
export * from "./CalendarShare.vue?vue&type=script&lang=js&"
import style0 from "./CalendarShare.vue?vue&type=style&index=0&id=19976c5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19976c5a",
  null
  
)

export default component.exports